const styles = {
  pageContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100vh',
    width: '100vw',
    backgroundColor: 'white.main',
    zIndex: 10
  },
  loadingContainer: {
    backgroundColor: '#FFF',
    flex: 1,
    height: 'calc(100vh - 5rem)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  snackbarAlert: {
    width: '100%'
  }
};

export default styles;
